import { render, staticRenderFns } from "./ImgDelete.vue?vue&type=template&id=665aebd7&lang=pug&"
import script from "./ImgDelete.vue?vue&type=script&lang=ts&"
export * from "./ImgDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImgDelete.vue"
export default component.exports